import MDBox from "components/MDBox";
import UiCard from "components/base/UiCard";
import UiTypography from "components/base/UiTypography";
import { Controller, useFormContext } from "react-hook-form";
import { UpdateProposalProductInputSchema } from "DDD/action-objects/StageProductUpdate";
import WYSIWYG from "components/WYSIWYG/WYSIWYG";
import { useRef, useState, useCallback } from "react";
import { useDraftContext } from "./DraftContext";

export default function StatementOfWork() {
  const { control, getValues, setValue } = useFormContext<UpdateProposalProductInputSchema>();
  const { isReadOnly } = useDraftContext();

  const [localContent, setLocalContent] = useState(getValues("material.statementOfWork") ?? "");
  const localRef = useRef(localContent);
  localRef.current = localContent;

  const plantProductsCount = (getValues("plantProducts") ?? []).length;

  const handleChange = useCallback((content?: string) => {
    setLocalContent(content ?? "");
  }, []);

  return (
    <UiCard variant="section">
      <MDBox px="8px" py="6px">
        <Controller
          control={control}
          name="material.statementOfWork"
          render={({ field }) => {
            const handleBlur = (event: any) => {
              const relatedTarget = event?.relatedTarget as HTMLElement | null;
              if (relatedTarget && relatedTarget.closest(".ck-toolbar")) return;
              if (localContent !== field.value) {
                field.onChange(localContent);
                setValue("material.statementOfWork", localContent, {
                  shouldDirty: true,
                  shouldTouch: true,
                });
              }
              field.onBlur?.();
            };
            return (
              <MDBox
                sx={{
                  "& > div > div:first-of-type": {
                    flexDirection: "row !important",
                    alignItems: "center !important",
                    mb: "4px !important",
                    gap: "8px !important",
                  },
                  "& > div > div:first-of-type::before": {
                    content: '"Statement of Work"',
                    fontSize: "9px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    color: "#474A5A",
                    whiteSpace: "nowrap",
                  },
                  "& .MuiFormControl-root": {
                    minWidth: "120px !important",
                    m: "0 !important",
                  },
                  "& .MuiSelect-select": {
                    minHeight: "28px !important",
                    fontSize: "11px !important",
                    py: "4px !important",
                  },
                  "& .ck-editor__top": { fontSize: "11px" },
                  "& .ck-editor__main": { minHeight: "60px", maxHeight: "120px", overflow: "auto" },
                  "& .ck-content": { fontSize: "12px", minHeight: "60px", padding: "4px 8px" },
                  "& .ck-toolbar": { padding: "2px 4px" },
                  "& .ck-toolbar__items .ck-button": {
                    minHeight: "22px",
                    minWidth: "22px",
                    padding: "2px",
                  },
                  "& .ck-dropdown__button": {
                    minHeight: "22px",
                    fontSize: "10px",
                    padding: "2px 4px",
                  },
                  "& .ck-dropdown__panel": { fontSize: "11px" },
                  "& .ck-list__item .ck-button": {
                    minHeight: "24px",
                    padding: "2px 8px",
                    fontSize: "11px",
                  },
                }}
              >
                <WYSIWYG
                  type="proposalProduct"
                  content={localContent}
                  onChange={handleChange}
                  title=""
                  onBlur={handleBlur}
                  plantProductsCount={plantProductsCount}
                  disabled={isReadOnly}
                />
              </MDBox>
            );
          }}
        />
      </MDBox>
    </UiCard>
  );
}
